import React, { ComponentProps } from "react";

export default function WarningIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M7.64196 2.3857L1.6045 12.8429C1.30758 13.3572 1.67873 14 2.27256 14H14.3475C14.9413 14 15.3124 13.3572 15.0155 12.8429L8.97808 2.3857C8.68116 1.87143 7.93887 1.87143 7.64196 2.3857Z"
        fill="white"
      />
      <path
        d="M8.31001 10.4417C8.07623 10.4417 7.87933 10.267 7.85152 10.0348L7.40988 6.34789C7.34525 5.80831 7.76658 5.3335 8.31001 5.3335C8.85344 5.3335 9.27478 5.80831 9.21015 6.34789L8.7685 10.0348C8.7407 10.267 8.5438 10.4417 8.31001 10.4417Z"
        fill="#FC4E5D"
      />
      <path
        d="M8.30981 12.5781C8.61575 12.5781 8.86376 12.3301 8.86376 12.0242C8.86376 11.7182 8.61575 11.4702 8.30981 11.4702C8.00387 11.4702 7.75586 11.7182 7.75586 12.0242C7.75586 12.3301 8.00387 12.5781 8.30981 12.5781Z"
        fill="#FC4E5D"
      />
    </svg>
  );
}
